/* Full-card secondary images for products tagged ZOOM only.
 * Original first images are never moved or resized.
 * The original swatch handlers remain responsible for selecting each image.
 * Touching an image previews it while pressed; the first tap opens the product.
 * The decorative hover layer never replaces the photo's native click target.
 * Delegated pointer events also cover cards inserted by filters/carousels. */
(function () {
  'use strict';

  var definitions = [
    { card: '.product-card-wrapper', host: '.card', area: '.card__inner', image: 'img.card-img-secondary', link: '.eyemode-card-photo-link[href], .card__heading a[href]' },
    { card: '.fct-product', area: '.fct-product-media', image: 'img.fct-product-img--secondary', link: 'a.fct-product-media[href], .fct-product-name a[href]' },
    { card: '.tcbc-product', area: '.tcbc-product-media', image: 'img.tcbc-product-img--secondary', link: 'a.tcbc-product-media[href], .tcbc-product-name a[href]' },
    { card: '.view-similar-card', host: '.view-similar-card__inner', area: '.view-similar-card__media', image: 'img.view-similar-card__image--secondary', link: '.view-similar-card__link' },
    { card: '.wishlist-item', area: '.wishlist-item-image', link: '.wishlist-item-title a[href]' },
    { card: '#recently-viewed-slider > .swiper-slide', area: '.img__d', link: 'a[href]:not(.eyemode-card-hover__layer)' }
  ];
  var selector = definitions.map(function (definition) { return definition.card; }).join(',');
  var states = new WeakMap();
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var currentState = null;
  var touchGesture = null;
  var controls = 'button, input, select, textarea, [role="button"], .card-color-swatch, .fct-swatch, .tcbc-swatch, .view-similar-card__swatch, .smartwishlist';

  function stop(state) {
    if (!state) return;
    state.hovered = false;
    state.touch = false;
    state.card.classList.remove('eyemode-card-hover--active', 'eyemode-card-hover--pending');
    if (currentState === state) currentState = null;
  }

  function showWhenLoaded(state) {
    var eligible = state.card.classList.contains('eyemode-card--zoom');
    var active = eligible && state.hovered && (state.touch || hoverQuery.matches) && state.signature !== '' &&
      state.image.complete && state.image.naturalWidth > 0;
    state.card.classList.toggle('eyemode-card-hover--active', active);
    state.card.classList.toggle('eyemode-card-hover--pending', eligible && state.hovered && !active);
  }

  function copyAttribute(image, name, value) {
    if (value) image.setAttribute(name, value);
    else image.removeAttribute(name);
  }

  function sync(state) {
    var definition = state.definition;
    state.source = definition.image ? state.card.querySelector(definition.image) : null;
    state.link = state.card.querySelector(definition.link);
    var src = state.source ? state.source.getAttribute('src') : state.card.getAttribute('data-eyemode-hover-src');
    var srcset = state.source ? state.source.getAttribute('srcset') : '';
    var sizes = state.source ? state.source.getAttribute('sizes') : '';
    var href = state.link && state.link.getAttribute('href');

    if ((!src && !srcset) || !href) {
      state.signature = '';
      showWhenLoaded(state);
      return;
    }

    if (state.layer.getAttribute('href') !== href) state.layer.setAttribute('href', href);
    var signature = JSON.stringify([src || '', srcset || '', sizes || '']);
    if (signature !== state.signature) {
      state.signature = signature;
      state.card.classList.remove('eyemode-card-hover--active');
      copyAttribute(state.image, 'sizes', sizes);
      copyAttribute(state.image, 'srcset', srcset);
      copyAttribute(state.image, 'src', src);
    }
    showWhenLoaded(state);
  }

  function createState(card) {
    var definition = definitions.find(function (item) { return card.matches(item.card); });
    var host = definition.host ? card.querySelector(definition.host) : card;
    if (!host) return null;

    // A carousel may copy an already enhanced card; discard its copied layer.
    Array.from(host.children).forEach(function (child) {
      if (child.classList.contains('eyemode-card-hover__layer')) child.remove();
    });
    card.classList.remove('eyemode-card-hover--active', 'eyemode-card-hover--pending');

    var layer = document.createElement('a');
    layer.className = 'eyemode-card-hover__layer';
    layer.setAttribute('aria-hidden', 'true');
    layer.setAttribute('tabindex', '-1');
    var image = document.createElement('img');
    image.className = 'eyemode-card-hover__image';
    image.alt = '';
    image.decoding = 'async';
    layer.appendChild(image);
    host.appendChild(layer);

    var state = {card: card, definition: definition, layer: layer, image: image, signature: '', hovered: false, touch: false};
    states.set(card, state);
    image.addEventListener('load', function () { showWhenLoaded(state); });
    image.addEventListener('error', function () {
      state.signature = '';
      showWhenLoaded(state);
    });

    // Sync only this card's selected secondary image, including swatch changes.
    state.observer = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.target !== image && record.target !== layer &&
          (record.type === 'childList' || record.target === state.source ||
           record.target === state.link || record.target === card);
      })) sync(state);
    });
    state.observer.observe(card, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes', 'href', 'data-eyemode-hover-src']
    });
    return state;
  }

  function findCard(event) {
    return event.target && event.target.closest ? event.target.closest(selector) : null;
  }

  function isControl(event) {
    return event.target && event.target.closest && event.target.closest(controls);
  }

  function imageTouch(card, definition, event) {
    if (event.target.closest('.eyemode-card-hover__layer')) return true;
    var area = card.querySelector(definition.area);
    if (!area) return false;
    // A stretched title link can sit on top of the image. Check its actual
    // location so tapping the title below the image still opens it directly.
    var rect = area.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right &&
      event.clientY >= rect.top && event.clientY <= rect.bottom;
  }

  function start(state, touch) {
    if (currentState && currentState !== state) stop(currentState);
    currentState = state;
    state.hovered = true;
    state.touch = touch;
    sync(state);
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch' || !hoverQuery.matches) return;
    var card = findCard(event);
    if (!card || !card.classList.contains('eyemode-card--zoom')) return;
    var state = states.get(card) || createState(card);
    if (!state || (state.hovered && !state.touch)) return;
    start(state, false);
  }, true);

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType === 'touch') return;
    var card = findCard(event);
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
    var state = states.get(card);
    if (state && !state.touch) stop(state);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'touch') return;
    touchGesture = null;
    if (event.isPrimary === false) {
      stop(currentState);
      return;
    }
    var card = findCard(event);
    if (currentState && currentState.touch && currentState.card !== card) stop(currentState);
    if (!card || !card.classList.contains('eyemode-card--zoom') || isControl(event)) return;
    var definition = definitions.find(function (item) { return card.matches(item.card); });
    if (!imageTouch(card, definition, event)) {
      if (currentState && currentState.touch) stop(currentState);
      return;
    }
    touchGesture = {card: card, definition: definition, id: event.pointerId,
      x: event.clientX, y: event.clientY, started: Date.now(), moved: false};
    var state = states.get(card) || createState(card);
    if (state) start(state, true);
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!touchGesture || touchGesture.id !== event.pointerId) return;
    if (Math.abs(event.clientX - touchGesture.x) > 12 || Math.abs(event.clientY - touchGesture.y) > 12) {
      touchGesture.moved = true;
      if (currentState && currentState.touch) stop(currentState);
    }
  }, true);

  document.addEventListener('pointerup', function (event) {
    if (!touchGesture || touchGesture.id !== event.pointerId) return;
    var gesture = touchGesture;
    touchGesture = null;
    if (gesture.moved || Date.now() - gesture.started > 600 ||
        Math.abs(event.clientX - gesture.x) > 12 || Math.abs(event.clientY - gesture.y) > 12 ||
        !gesture.card.contains(event.target) || isControl(event)) {
      stop(states.get(gesture.card));
    }
    // Never cancel or replace the click: the browser follows the existing
    // product/variant link, and the carousel can still suppress drag clicks.
  }, true);

  function reset() {
    touchGesture = null;
    stop(currentState);
  }

  document.addEventListener('scroll', function () {
    if (touchGesture) touchGesture.moved = true;
    if (currentState && currentState.touch) stop(currentState);
  }, true);
  document.addEventListener('pointercancel', reset, true);
  window.addEventListener('blur', reset);
  hoverQuery.addEventListener('change', reset);
}());
